module.exports = __webpack_public_path__ + "img/car.b15b0c4d.png";